import { useEffect, useState } from "react";
import ExitIntent from "../../helpers/ExitIntent";
import Icon from "../Icon";

const ONE_MONTH = 1000 * 60 * 60 * 24 * 3;

const ExitPopup = () => {
	const [showPopup, setShowPopup] = useState(false);
	const [userClosedPopup, setUserClosedPopup] = useState(false);
	const [startTime] = useState(Date.now());

	useEffect(() => {
		if (typeof window !== "undefined") {
			if (localStorage?.getItem("exit-popup-closed")) {
				const closeTime = new Date(localStorage.getItem("exit-popup-closed"));
				const userLastSeen = new Date().getTime() - closeTime.getTime();
				if (userLastSeen < ONE_MONTH) {
					setUserClosedPopup(true);
				}
			}
		}

		const removeExitIntent = ExitIntent({
			threshold: 30,
			eventThrottle: 100,
			onExitIntent: () => {
				if (Date.now() - startTime < 2000) {
					return false;
				}

				if (showPopup === false) {
					setShowPopup(true);
					return true;
				}
				return false;
			},
		});
		return () => {
			removeExitIntent();
		};
	}, []);

	const handleClose = () => {
		setShowPopup(false);
		localStorage?.setItem("exit-popup-closed", new Date().toString());
	};

	if (userClosedPopup) {
		return null;
	}

	return (
		<div className={`exit-popup ${showPopup ? "visible" : ""}`}>
			<div className="exit-popup-content bg-gray-white d-flex flex-column flex-md-row m-0">
				<div className="row bg-white pt-7 pb-12 pt-md-15 pb-md-10 px-6 px-md-12 m-0 d-flex align-items-center justify-content-center border border-dark position-relative">
					<div className="z-3 col-12 text-center " style={{ maxWidth: 600 }}>
						<h2 className="pb-4 pb-md-6 h2 mx-auto">
							Get <span className="text-mid-green font-family-young">FREE</span> Leadership Insights
						</h2>
						<p className="font-size-lg m-0 mx-auto pb-7 pb-md-8">
							Join Spark! for monthly expert coaching perspectives from our founder on workplace trends that help you
							develop high performing teams.
						</p>
					</div>
					<div className="z-3 col-12 d-flex align-items-center justify-content-center flex-column flex-md-row">
						<getresponse-form form-id="4b5cade4-1f75-46a8-a94b-14c0a97dc329" e="1"></getresponse-form>
					</div>
					<div className={`box-behind-main box-behind-main-10 bg-white`}></div>
				</div>
				<div className="close-wrapper">
					<div className="cursor-pointer">
						<Icon name="close" width={36} height={36} onClick={handleClose} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default ExitPopup;
